var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading-pepper"},[_c('div',{staticClass:"background",style:(_vm.backgroundStyle)},[_c('img',{style:(_vm.pepperStyle),attrs:{"src":_vm.pepperUrl,"role":"img","tabindex":"0","alt":"Pepper loader"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }